import api from '../../lib/api';
import { url_api_v1_user_skills_add, url_api_v1_user_skills_get, url_api_v1_user_skills_search } from '../../lib/apiUrl';

export interface UserSkill {
    id: number;
    uuid: string;
    name: string;
    master_special_skill_id?: number;
}

export interface MasterSkill {
    id: number;
    uuid: string;
    name: string;
    sub_skill: string;
    display_name: string;
    count?: number;
}

export interface OverviewResponse {
    success: boolean;
    general_information: string;
    skills: UserSkill[];
    message?: string;
}

export interface MasterSkillSearchResponse {
    success: boolean;
    skills: MasterSkill[];
}

class UserSkillsService {
    // GET /api/v1/user_skills - Fetch overview data (general info + skills)
    getOverview = async (userId?: string): Promise<OverviewResponse> => {
        try {
            const url = userId
                ? `${url_api_v1_user_skills_get}?user_id=${userId}`
                : url_api_v1_user_skills_get;
            const response = await api.get(url);
            if (response.status !== 200) {
                throw new Error('Error getting overview data.');
            }
            return response.data;
        } catch (error) {
            throw error;
        }
    };

    // PATCH /api/v1/user_skills - Save general info + skills together
    updateOverview = async (generalInformation: string, skills: UserSkill[]): Promise<OverviewResponse> => {
        try {
            const response = await api.patch(url_api_v1_user_skills_add, {
                general_information: generalInformation,
                skills: skills
            });
            if (response.status !== 200 && response.status !== 201) {
                throw new Error('Error updating overview.');
            }
            return response.data;
        } catch (error) {
            throw error;
        }
    };

    // GET /api/v1/user_skills/search - Search master skills
    searchMasterSkills = async (query: string): Promise<MasterSkillSearchResponse> => {
        try {
            const response = await api.get(`${url_api_v1_user_skills_search}?q=${encodeURIComponent(query)}`);
            if (response.status !== 200) {
                throw new Error('Error searching skills.');
            }
            return response.data;
        } catch (error) {
            throw error;
        }
    };
}

const userSkillsService = new UserSkillsService();

export default userSkillsService;
